import {useSelector} from 'react-redux';

import {configSelectors} from '../../Config';


function useSourceContentLanguages() {

    return useSelector(configSelectors.getSourceContentLanguages);
}


export default useSourceContentLanguages;
